// src/modules/app-views/leads/pages/Init/modals/LeadsParametersModal/modals/MetaConnectModal/Step2.jsx
// *******************************************************************************
// Step 2: Select Facebook Page to subscribe to leadgen events
// Reads pages from the hidden form field _pages (set by Step1) and displays them
// as a radio group. The selected page ID is stored in _pageId for onFinish.
// *******************************************************************************
import { Form, Radio, Flex, Tag, Empty } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useSimpleFormContext } from 'components/SimpleComponents/SimpleFormProvider';
import translateX from 'utils/translateX';

// *******************************************************************************
// STEP CONTENT
// *******************************************************************************
const Step2Content = () => {
  const { form } = useSimpleFormContext();

  // Read pages stored by Step1
  const pages = form.getFieldValue('_pages') || [];

  if (!pages.length) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={translateX('meta_no_pages_found')}
      />
    );
  }

  return (
    <Form.Item
      name="_pageId"
      label={translateX('select_facebook_page')}
      required
      rules={[{ required: true, message: () => translateX('required_field') }]}
    >
      <Radio.Group style={{ width: '100%' }}>
        <Flex vertical gap={8}>
          {pages.map(page => (
            <Radio
              key={page.id}
              value={page.id}
              style={{
                padding: '10px 12px',
                border: '1px solid #d9d9d9',
                borderRadius: 8,
                width: '100%',
              }}
            >
              <Flex align="center" gap={8}>
                <GlobalOutlined style={{ color: '#1877F2' }} />
                <span style={{ fontWeight: 600 }}>{page.name}</span>
                {page.category && (
                  <Tag color="blue" style={{ marginLeft: 4 }}>
                    {page.category}
                  </Tag>
                )}
              </Flex>
            </Radio>
          ))}
        </Flex>
      </Radio.Group>
    </Form.Item>
  );
};

// *******************************************************************************
// STEP BUILDER
// *******************************************************************************
const step2 = () => ({
  stepTitle: 'select_facebook_page',
  content: () => <Step2Content />,
  validationFields: ['_pageId'],
});

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default step2;
